"use client";

import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import { isWindow } from "@/service/render-environment";
import { useEffect } from "react";

function detectAddToFavourite(element: HTMLElement) {
  return (
    element.classList.contains("add-to-favourite__add") ||
    element.classList.contains("add-to-favourite__delete")
  );
}

const isEllipsisActive = (element: any) =>
  element.offsetWidth < element.scrollWidth;

export default function TooltipClient() {
  useEffect(() => {
    const interval = setInterval(() => {
      const isTouchScreen =
        (isWindow() && "ontouchstart" in window) ||
        navigator.maxTouchPoints > 0;

      const interactiveClasses = [
        "editor-source",
        "event-specializations",
        "med-warnings",
      ];

      Array.from(
        document.querySelectorAll(
          ".calculator-input div:not(.schema-driven-calculator-inputs) [title]",
        ),
      ).forEach((element) => {
        element.setAttribute("data-title", element.getAttribute("title"));
        element.dataset.title = element.getAttribute("title");
        element.removeAttribute("title");
      });

      Array.from(document.querySelectorAll<HTMLElement>("[data-title]")).map(
        (element) => {
          if (element.closest("[data-sonner-toast]")) {
            return;
          }

          if (element._tippy) {
            element._tippy.destroy();
          }

          if (element.dataset.title === "DESTROY") {
            return;
          }

          if (isTouchScreen && detectAddToFavourite(element)) {
            delete element.dataset.title;
            return;
          }
          const options = {
            content: element.dataset.title,
            allowHTML: true,
            appendTo: () => document.body,
            interactive: interactiveClasses.includes(
              element.getAttribute("class") as string,
            ),
            maxWidth: window.innerWidth < 600 ? 350 : 540,
            onCreate(instance) {
              if (element.dataset.tooltipClassname) {
                instance.popper.classList.add(element.dataset.tooltipClassname);
              }
            },
          };

          if (element.dataset.interactive !== undefined) {
            options.interactive = true;
            delete element.dataset.interactive;
          }

          tippy(element, options);

          delete element.dataset.title;
        },
      );
    }, 100);

    return () => {
      clearInterval(interval);
    };
  });

  return <></>;
}
